import { AxiosInstance } from "axios";

export function setupErrorInterceptor(api: AxiosInstance) {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        switch (error.response.status) {
          case 400:
            console.error("Requisição mal formatada");
            break;
          case 401:
            // Tratado no auth interceptor
            break;
          case 403:
            console.error("Acesso negado");
            break;
          case 404:
            console.error("Recurso não encontrado");
            break;
          case 500:
            console.error("Erro interno do servidor");
            break;
          default:
            console.error("Ocorreu um erro na requisição");
        }
      } else if (error.request) {
        // A requisição foi feita mas não houve resposta
        console.error("Não foi possível comunicar com o servidor");
      } else {
        // Erro na configuração da requisição
        console.error("Erro ao configurar a requisição");
      }

      return Promise.reject(error);
    },
  );
}
